<template>
  <modal name="add-new-solution-modal-dialog" transition="pop-out" width="95%" height="auto"
         :scrollable="true" @before-open="beforeOpen" @opened="whenOpened">
    <div class="pmis-presentation-container">
      <b-container fluid>
        <b-row>
          <b-col>
            <hr/>
            <p class="title-add-solution"><img src="pic/pmis-logo.png"> Obrazec za dodajanje novega igrala <img src="pic/pmis-logo.png"> </p>
            <hr/>
          </b-col>
        </b-row>
        <b-row class="input-row">
          <b-col cols="2" class="font-weight-normal pmis-presentation-text">Elektronski naslov prijavitelja:</b-col>
          <b-col cols="5" id="form-email">
            <b-form-input type="email" id="email" name="email"/>
          </b-col>
        </b-row>
        <b-row class="input-row">
          <b-col cols="2" class="font-weight-normal pmis-presentation-text">Področja:</b-col>
          <b-col cols="4" id="form-categories">
            <multiselect placeholder="Izberi področja" v-model="selectedCategories" track-by="name" label="name" :searchable="false" :options="categories" :multiple="true" :close-on-select="false" :show-labels="false" :hide-selected="true"></multiselect>
          </b-col>
        </b-row>
        <b-row class="input-row">
          <b-col cols="2" class="font-weight-normal pmis-presentation-text">Razpored slik:</b-col>
          <b-col cols="4" id="form-pics-layout">
            <multiselect track-by="name" label="name" v-model="selectedLayout" :options="layoutOptions" :show-labels="false"></multiselect>
          </b-col>
        </b-row>
      </b-container>

      <PmisFormPresentation :name="theme" :layout="selectedLayout"></PmisFormPresentation>
      <PmisInfoFooterContainer id="footer-edit" :edit="true" :name="theme" idx="2" :categories="selectedCategories"></PmisInfoFooterContainer>

      <b-container fluid>
        <b-row>
          <b-col align="center">
            <hr/>
            <b-button variant="info" @click="recaptcha" style="margin-right: 10px;" v-show="false">Recaptcha</b-button>
            <!--<b-button variant="info" :pressed.sync="showHelpTooltips" style="margin-right: 10px;">Pomoč</b-button>-->
            <b-button variant="success" v-on:click="saveAndClose()" style="margin: 0px 10px; background-color: #009EB2;">Pošlji</b-button>
            <b-button variant="danger" style="margin-left: 10px; background-color: #CB6D68;" v-on:click="$modal.hide('add-new-solution-modal-dialog')">Zapri</b-button>
          </b-col>
        </b-row>
      </b-container>

      <b-tooltip :show.sync="showHelpTooltips" target="form-email" placement="right" triggers="manual">
        Vaš elektronski naslov.
      </b-tooltip>
      <b-tooltip :show.sync="showHelpTooltips" target="form-categories" placement="right" triggers="manual">
        Področja, kamor spada to igralo.
      </b-tooltip>
      <b-tooltip :show.sync="showHelpTooltips" target="form-pics-layout" placement="right" triggers="manual">
        Postavitev in število slik igrala.
      </b-tooltip>

      <b-tooltip :show.sync="showHelpTooltips" target="new-solution-title" placement="right" triggers="manual">
        Ime igrala.
      </b-tooltip>

      <b-tooltip :show.sync="showHelpTooltips" target="new-solution-features" placement="right" triggers="manual">
        Ključne lastnosti igrala.
      </b-tooltip>

      <b-tooltip :show.sync="showHelpTooltips" target="new-solution-images" placement="top" triggers="manual">
        Slike igrala.
      </b-tooltip>

      <b-tooltip :show.sync="showHelpTooltips" target="footer-edit" placement="rightbottom" triggers="manual">
        Navodila pomagajo pri spoznavanju možnosti uporabe.
      </b-tooltip>


    </div>
    <loading :active.sync="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage"></loading>
  </modal>
</template>
<script>
import presentation from "./../data/presentation";
import PmisInfoFooterContainer from "./../presentation/PmisInfoFooterContainer";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {dom, library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {faTwitter} from '@fortawesome/free-brands-svg-icons'
import axios from 'axios';
import Multiselect from 'vue-multiselect';
// import PmisTitle from "../title/PmisTitle";
//import qs from 'qs';

import JQuery from 'jquery'
import PmisFormPresentation from "../presentation/form/PmisFormPresentation";
import {pmisPlaygroundCategoriesMixin} from "../../mixins/pmis-playground-categories-mixin";

let $ = JQuery;

library.add(fas, faTwitter);

// Kicks off the process of finding <i> tags and replacing with <svg>
dom.watch();

// import JQuery from 'jquery'
// let $ = JQuery;

// const MARGIN_FACTOR = 0.9;

export default {
  name: 'AddNewSolutionModalDialog',
  components: {
    Loading, PmisFormPresentation, PmisInfoFooterContainer, Multiselect
  },
  mixins: [pmisPlaygroundCategoriesMixin],
  data() {
    return {
      showHelpTooltips: false,
      selectedCategories: [],
      layoutOptions: [
        {
          "pics": 1,
          "name": "1x velika slika"
        },
        {
          "pics": 4,
          "name": "4x manjša slika"
        }
      ],
      selectedLayout: {
        "pics": 1,
        "name": "1x velika slika"
      },
      valuesFunctionality: [""],
      valuesVideo: [""],
      valuesPrecondition: [""],
      // items: [{
      //     modalWidth: window.innerWidth * MARGIN_FACTOR,
      //     titleHeight: window.innerHeight * (1 - MARGIN_FACTOR),
      // }],
      email: '',
      reg: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      appTitle: '',
      appFunctionTitle: [],
      appFunctionDescription: [],
      appPreconditionDescription: [],
      appPreconditionUrl: [],
      appVideoTile: [],
      appVideoTime: [],
      appVideoDescription: [],
      isLoading: true,
      fullPage: false,
      title: '...',
      src: "#",
      backgroundColor: "white",
      name: '',
      demoAccount: '',
      createAccount: '',
      installOwn: '',
      useCases: '',
      theme: "default",
      input: "",
      value: "",
      value2: "aaa",
      options: {
        lineNumbers: true,
        lineWrapping: true,
      }

    }
  },
  mounted: function () {
    // $('.rect').css({'width': $('.rect').height() + 'px'});
    $('.rect').css({'width': 58 + 'px'});
    $('.rect-small').css({'width': $('.rect-small').height() + 'px'});
  },
  created() {
    // this.modalWidth = window.innerWidth * MARGIN_FACTOR;
    // this.titleHeight = window.innerHeight * (1 - MARGIN_FACTOR);
    /*
    var v = Array.from(this.valuesFunctionality);
    console.debug(JSON.stringify(this.valuesFunctionality));
    console.debug(JSON.stringify(v));
    this.valuesFunctionality = v;
    */
  },
  methods: {
    recaptcha() {
      console.log("recaptcha clicked");
      this.$recaptchaLoaded().then(() => {
        console.log("recaptcha loaded");
        this.$recaptcha("login").then((token) => {
          console.log(token); // Will print the token
        });
      });
    },
    beforeOpen(event) {
      this.title = event.params.title;
    },
    onCancel() {
      // console.log('User cancelled the loader.')
    },
    whenOpened() {
      this.isLoading = false;
      var position = $("#footer-edit").offset();
      var positionStr = (window.innerHeight / (position.top - 150)) * 100 + "%";
      $(".bottom-left").css({"top": positionStr});
    },
    updateValue: function () {
      // console.debug(JSON.stringify(this.values));
      this.$emit('input', this.values);
    },
    deleteFunctionalityValue: function (index) {
      this.valuesFunctionality.splice(index, 1);
      this.$emit('input', this.valuesFunctionality);
    },
    deleteVideoValue: function (index) {
      this.valuesVideo.splice(index, 1);
      this.$emit('input', this.valuesVideo);
    },
    deletePreconditionValue: function (index) {
      this.valuesPrecondition.splice(index, 1);
      this.$emit('input', this.valuesPrecondition);
    },
    addVideoValue: function () {
      this.valuesVideo.push({});
      this.$emit('input', this.valuesVideo);
    },
    addFunctionalityValue: function () {
      this.valuesFunctionality.push({});
      this.$emit('input', this.valuesFunctionality);
    },
    addPreconditionValue: function () {
      this.valuesPrecondition.push({});
      this.$emit('input', this.valuesPrecondition);
    },
    errorFunctionalityBool: function (index) {
      return this.index > 0 ? true : (this.appFunctionTitle[index] === undefined ||
          this.appFunctionTitle[index].length < 5) ? false : true;
    },
    changeTheme(elem) {
      this.theme = elem.tema;
    },
    submitSolution: function () {
      //validate the data
      var dataNotLegit = false;

      if (!this.errorEmailInputBool || !this.errorNameInputBool || !this.errorDemoAccountInputBool ||
          !this.errorAccounCreationInputBool || !this.errorUseCaseInputBool || !this.errorInstallInputBool ||
          !this.errorFunctionalityBool(0))
        dataNotLegit = true;

      if (dataNotLegit) {
        this.$toast.open({
          message: 'Potrebno je popraviti ali dopolniti podatke na vnosni formi.',
          type: 'warning',
          duration: 5000,
          dismissible: true,
          queue: false,
          position: 'top',
          onClose: this.onClose
        });
      }

      /*   'success',
          'error',
          'warning',
          'info',
          'default',

       */

    },
    saveAndClose() {
      try {
        // var blob = new Blob(["Hello, world!"], {type: "text/plain;charset=utf-8"});
        // saveAs(blob, "new_solution.json");

        const toast = this.$toast;
        const onClose = this.onClose;
        toast.open({
          message: "Shranjevanje rešitve... Prosimo počakajte...",
          type: 'default',
          duration: 3000,
          dismissible: true,
          queue: false,
          position: 'top',
          onClose: onClose
        });

        let images = [];
        if (this.selectedLayout.pics === 1) {
          images = [
            {
              "src": $("#image-chooser-5").css('background-image'),
              "sizes": {
                "lg": 12
              }
            }
          ];
        } else {
          images = [
            {
              "src": $("#image-chooser-0").css('background-image'),
              "sizes": {
                "lg": 6
              }
            },
            {
              "src": $("#image-chooser-1").css('background-image'),
              "sizes": {
                "lg": 6
              }
            },
            {
              "src": $("#image-chooser-2").css('background-image'),
              "sizes": {
                "lg": 6
              }
            },
            {
              "src": $("#image-chooser-3").css('background-image'),
              "sizes": {
                "lg": 6
              }
            }
          ]
        }

        const data = {
          "title": $("input#new-solution-title").val(),
          "demoSrc": "",
          "categories": this.selectedCategories,
          "email": $("input#email").val(),
          "markdown": $("textarea#makrdown-content").val(),
          "color-theme": this.theme,
          "images": images,
          "menu": [
            {
              "content": {
                "title": "Lastnosti",
                "items": [
                  {
                    "title": $("input#Lastnost_1").val(),
                  },
                  {
                    "title": $("input#Lastnost_2").val(),
                  },
                  {
                    "title": $("input#Lastnost_3").val(),
                  },
                  {
                    "title": $("input#Lastnost_4").val(),
                  },
                  {
                    "title": $("input#Lastnost_5").val(),
                  }
                ]
              }
            },
          ]
        };

        // localStorage.setItem('new_solution', JSON.stringify(data));

        // perform POST request
        var url = '/api/igralnica/dodaj/igralo';

        const options = {
          method: 'POST',
          headers: {'content-type': 'application/json'},
          data: JSON.stringify(data),
          url: url,
        };

        axios(options).then(function (response) {
          if (response.status == 200) {
            toast.open({
              message: "Igralo z naslovom '" + data.title + "' je bilo uspešno predlagano. O nadaljnjih korakih boste obveščeni po elektronski pošti.",
              type: 'success',
              duration: 7000,
              dismissible: true,
              queue: false,
              position: 'top',
              onClose: onClose
            });
          } else {
            toast.open({
              message: "Pri shranjevanju je žal prišlo do napake. " + response.data.status,
              type: 'error',
              duration: 7000,
              dismissible: true,
              queue: false,
              position: 'top',
              onClose: onClose
            });

          }
        }).catch(function (error) {
          //error code
          // error.response.status

          let msg = "Pri shranjevanju je žal prišlo do napake. Če se to pojavlja, nas prosimo kontaktirajte na: " + window._env_.ADMIN_EMAIL + " .";

          if (error.response && error.response.data.hasOwnProperty("status")) {
            msg = "Pri shranjevanju je žal prišlo do napake; " + error.response.data.status;
          }

          toast.open({
            message: msg,
            type: 'error',
            duration: 7000,
            dismissible: true,
            queue: false,
            position: 'top',
            onClose: onClose
          });

        });

        // this.$toast.open({
        //     message: 'Vaš pedlog je bil uspešno posredovan komisiji SRIP PMiS. V najkrajšem možnem času boste obveščeni o nadaljnjih postopkih.',
        //     type: 'success',
        //     duration: 5000,
        //     dismissible: true,
        //     queue: false,
        //     position: 'top-right',
        //     onClose: this.onClose
        // });

        // this.$modal.hide('add-new-solution-modal-dialog');
        // this.$router.go('/');
      } catch (err) {
        console.log(err);
      }
    },
    updateImageLayout(layout) {
      console.log(layout.pics);
      if (this.selectedLayout.pics === 1) {
        $("#multiple_image_container").hide();
        $(".image-uploader").css('height', '500px !important');
        $("#single_image_container").fadeIn("500");
      } else {
        $("#single_image_container").hide();
        $(".image-uploader").css('height', '250px !important');
        $("#multiple_image_container").fadeIn("500");
      }
    }
  },
  computed: {
    getThemes() {
      return presentation["dodaj-resitev"].teme;
    },
    errorEmailInputBool: function () {
      return (this.email == "") ? false : (this.reg.test(this.email)) ? true : false;
    },
    errorEmailInputMsg: function () {
      return (this.email == "") ? "" : (this.reg.test(this.email)) ? "" : "Vpišite veljaven elektronski naslov";
    },
    errorNameInputBool: function () {
      return (this.appTitle == "") ? false : this.appTitle.length > 2 ? true : false
    },
    errorNameInputMsg: function () {
      return (this.appTitle == "") ? "" : this.appTitle.length > 2 ? "" : "Dolžina naslova igrala mora biti vsaj 3 znake";
    },
    errorDemoAccountInputBool: function () {
      return (this.demoAccount == "") ? false : this.demoAccount.length > 4 ? true : false;
    },
    errorAccounCreationInputBool: function () {
      return (this.createAccount == "") ? false : this.createAccount.length > 4 ? true : false;
    },
    errorUseCaseInputBool: function () {
      return (this.useCases == "") ? false : this.useCases.length > 4 ? true : false;
    },
    errorInstallInputBool: function () {
      return (this.installOwn == "") ? false : this.installOwn.length > 4 ? true : false;
    }
  }
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>

.pmis-presentation-text {
  font-family: "Roboto";
  font-size: 1.1em;
}

.input-row {
  margin-bottom: 10px;
}

.flex-container {
  padding: 0;
  margin: 0;
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row;
  justify-content: space-around;
  line-height:30px;
}

.flex-item {
  background: tomato;
  margin: 5px;
  color: white;
  font-weight: bold;
  font-size: 1.5em;
  text-align: center;
  flex: 1 0 0px;
  min-width: 1.5em;
}
.flex-item:before {
  content: "";
  display: block;
  padding-top: 100%;
  float: left;
}


.hint-container {
  position: absolute;
  display: none;
  opacity: .95;
  z-index: 20;
  /*width: inherit;*/
  /*height: 100px;*/
  background-color: #b37e90;
  /*color: red;*/
  width: 200px;
  height: 60px;

  text-align: right;
  vertical-align: middle;
  /*line-height: 90px;*/
  /*border-style: solid;*/
  /*border-width: 0 50px 50px 50px;*/
  /*border-color: transparent transparent #b37e90 transparent;*/
}

/*URL source:*/
/*https://bennettfeely.com/clippy/*/
.arrow-left {
  clip-path: polygon(25% 0%, 100% 1%, 100% 100%, 25% 100%, 0% 50%);
}

.arrow-right {
  width: 150px;
  clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
}

.arrow-up {
  clip-path: polygon(0 40%, 50% 13%, 100% 40%, 100% 100%, 0% 100%);
}

.arrow-down {
  clip-path: polygon(0 58%, 0 0, 100% 0, 100% 58%, 50% 84%);
}

.arrow-left-text {
  margin-top: -25px;
  margin-left: 55px;
  width: 170px !important;
}

.hint-container span {
  position: relative;
  left: -40px;
  top: 30px;
  width: 100px;
  color: white;
  /*top: 10px;*/
}

.square {
  width: 25%;
  height: 0;
  padding-bottom: 25%;
}

.grid {
  display: block;
  padding: 0;
  margin: 0 -6px 12px;
  text-align: left;
  font-size: 0;
}

.grid-cell {
  display: inline-block;
  margin: 0;
  padding: 0 6px;
  text-align: left;
  vertical-align: top;
  width: 100%;
  font-size: 16px;
}

.grid-25 {
  height: 50%;
  border: 2px solid #d8eff0;
}

.top-left {
  top: 9.7%;
  left: 10.4%;
}

.top-center {
  top: 2.5%;
  left: 47%;
}

.top-right {
  top: 6.2%;
  left: 81.5%;
}

.title-left {
  top: 18.3%;
  left: 22%;
}

.properties-left {
  top: 48%;
  left: 22%;
}

.bottom-left {
  left: 6%;
}

/*#container:after {*/
/*    content: " ";*/
/*    display: inline-block;*/
/*    width: 0;*/
/*    height: 0;*/
/*    border-style: solid;*/
/*    border-width: 40px 0 40px 20px;*/
/*    border-color: #ebebeb #ebebeb #ebebeb transparent;*/
/*}*/

.myfas {
  width: auto;
  height: 20px;
}

.right {
  text-align: right;
  float: right;
}

.input_form::after {
  /*content: ":";*/
}

div[role=group] {
  display: block;
  clear: both;
}

.error {
  font-weight: lighter;
  font-size: small;
  background-color: #fce4e4;
  border: 1px solid #fcc2c3;
  float: left;
  /*padding: 20px 30px;*/
}

.form {
  /*margin-top: 5px;*/
  /*margin-bottom: 5px;*/
  width: 100%;
}

label {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: right;
  margin: 0px;
}

.success {
  background-color: #4CAF50;
}

.dialog-button {
  background-color: #2b78fc;
  border: none;
  color: white;
  margin: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

.color-group {
  padding: 2px;
}

.single-rect-layout:hover {
  border: 2px solid #338ff9;
}

.color-group:hover {
  /*border-radius: 10px;*/
  /*border: 1px solid darkgrey;*/
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,f3f3f3+3,f3f3f3+3,f3f3f3+7,ededed+8,ededed+8,ffffff+100 */
  background: #ffffff; /* Old browsers */
  background: -moz-linear-gradient(-45deg, #ffffff 0%, #f3f3f3 3%, #f3f3f3 3%, #f3f3f3 7%, #ededed 8%, #ededed 8%, #ffffff 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(-45deg, #ffffff 0%, #f3f3f3 3%, #f3f3f3 3%, #f3f3f3 7%, #ededed 8%, #ededed 8%, #ffffff 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(135deg, #ffffff 0%, #f3f3f3 3%, #f3f3f3 3%, #f3f3f3 7%, #ededed 8%, #ededed 8%, #ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#ffffff', GradientType=1); /* IE6-9 fallback on horizontal gradient */

}

.pmis-presentation-container {
  margin: 10px 5% 20px 5%;
}

#editor {
  margin: 0;
  height: 100%;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

#add-tool-markup {
  display: none;
}

textarea, #editor div {
  display: inline-block;
  width: 49%;
  height: 100%;
  vertical-align: top;
  box-sizing: border-box;
  padding: 0 20px;
}

textarea {
  border: none;
  border-right: 1px solid #ccc;
  resize: none;
  outline: none;
  background-color: #f6f6f6;
  font-size: 14px;
  font-family: 'Monaco', courier, monospace;
  padding: 20px;
}

code {
  color: #f66;
}

.close-button {
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 20px;
  padding-right: 20px;
}

.odmik-barva {
  margin-bottom: 10px;
}

.rect {
  height: 100%;
  float: right;
  width: 87px;
  padding: 10px;
  border: 2px solid #d8eff0;
}

.rect-small {
  height: 100%;
  width: 50%;
  /*padding: 2.5%;*/
  margin-right: 4px;
  margin-bottom: 4px;
  border: 2px solid #d8eff0;
}

.rect-col {
  padding: 5px;
  width: 50px;
}

.rect-row {
  height: 50%;
}

.left {
  float: left;
}

.right {
  float: right;
}

#multiple_img_layout:hover .rect-small {
  border: 2px solid #338ff9;
}

#multiple_img_layout {
  padding: 5px;
}

#single_img_layout_container {
  padding: 10px;
  display: flex;
}

span {
  border-radius: 5px;
  width: 35px;
  height: 35px;
  float: left;
  display: inline-block;
}

.title-add-solution {
  text-align: center;
  font-size: 2em;
}
</style>
